/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';

const InjurySummaryTableRow = ({rowHeader, rowContent, rowClassName }) => {
  return (
    <div className={rowClassName}>
      <div className="header">
        {rowHeader}
      </div>
      <div className="content">
        {rowContent}
      </div>
    </div>
  );
};

InjurySummaryTableRow.propTypes = {
  rowHeader: PropTypes.string.isRequired,
  rowClassName: PropTypes.string,
  rowContent: PropTypes.oneOfType([
    PropTypes.string, PropTypes.number
  ]).isRequired
};

export default InjurySummaryTableRow;



/** WEBPACK FOOTER **
 ** ./src/components/injurySummary/InjurySummaryTable/InjurySummaryTableRow.js
 **/